import { isThirdParty } from "le-coffre-resources/dist/MemberTypes";

export enum PROVIDER_OPENID {
	idNot = "idNot",
}

export interface UserJwtPayload {
	userId: string;
	email: string | null;
	openId?: {
		providerName?: string;
		userId?: string | number;
	};
	office_Id?: string | null;
	role?: string;
	officeRole?: string | null;
	isSuperAdmin?: boolean;
	hasActiveSubscription?: boolean;
	isVisitor?: boolean;
	userType?: string;
	folderUid?: string | null;
	rules?: string[];
	exp?: number;
}

export interface CustomerJwtPayload {
	customerId: string;
	email: string;
	exp?: number;
}

export type AnyJwtPayload = Partial<
	UserJwtPayload & {
		customerId: string;
		email: string | undefined | null;
	}
>;

export const isUserJwtPayload = (payload: AnyJwtPayload | null | undefined): payload is UserJwtPayload => {
	if (!payload || typeof payload !== "object") {
		return false;
	}
	const maybeUser = payload as Partial<UserJwtPayload>;
	return typeof maybeUser.userId === "string";
};

export const isCustomerJwtPayload = (payload: AnyJwtPayload | null | undefined): payload is CustomerJwtPayload => {
	if (!payload || typeof payload !== "object") {
		return false;
	}
	const maybeCustomer = payload as Partial<CustomerJwtPayload>;
	return typeof maybeCustomer.customerId === "string";
};

export const isThirdPartyJwtPayload = (payload: AnyJwtPayload | null | undefined): boolean => {
	if (!payload || typeof payload !== "object") {
		return false;
	}
	const maybeThirdParty = payload as Partial<UserJwtPayload>;
	return (
		typeof maybeThirdParty.userId === "string" &&
		isThirdParty(maybeThirdParty.userType) &&
		typeof maybeThirdParty.folderUid === "string"
	);
};

export const isIdNotNotaryPayload = (payload: UserJwtPayload | null | undefined): boolean => {
	if (!payload) {
		return false;
	}
	const provider = payload.openId?.providerName;
	return provider === PROVIDER_OPENID.idNot && !isThirdParty(payload.userType) && payload.isVisitor !== true;
};

export const getJwtExpiration = (payload: AnyJwtPayload | null | undefined): number | null => {
	if (!payload || typeof payload.exp !== "number") {
		return null;
	}
	return payload.exp;
};
